module.exports = __webpack_public_path__ + "img/bg05.8a3df671.gif";